import ProcessTimeline from "@/components/SelfProcessTimeline";
import CommonModal from "@/components/ui/CommonModal";
import {
  FlowFormPanelLayout,
  FormSectionLayout,
} from "@/components/ui/FlowFormPanel/FlowFormPanel";
import { useModal } from "@/hooks/modals/useModal";
import { useFlowNodeQuery } from "@/hooks/services/useFlow";
import { Form } from "antd";
import { useFormFooter } from "../hooks/useFormFooter";
import { useInitFormFields } from "../hooks/useInitFormFields";
import { useSourcingRequirementQuery } from "../hooks/useSourcingRequirementQuery";
import type { SourcingRequirementApplicationFormFields } from "../type";
import { SourcingRequirementApplicationForm } from "./SourcingRequirementApplicationForm";
import { useTranslation } from "react-i18next";

const checkIsFlowFinished = (reviewStatus?: number) => {
  if (!reviewStatus) {
    return false;
  }
  return [3, 4].includes(reviewStatus);
};

// 寻源申请弹窗
export function SourcingRequirementApplicationModal() {
  const { t } = useTranslation("sourcingRequirementManagement");
  const { open, props, closeModal } = useModal("SOURCING_APPLICATION_20251202");

  const { recordId } = props;

  const [form] = Form.useForm<SourcingRequirementApplicationFormFields>();

  const detail = useSourcingRequirementQuery(recordId);

  const isFlowFinished = checkIsFlowFinished(detail?.reviewStatus);

  useInitFormFields(form, open, detail);

  const timeLineItems = useFlowNodeQuery(detail?.insId);

  const cleanup = () => {
    form.resetFields();
    closeModal();
  };

  const renderFooter = useFormFooter(form, cleanup);

  return (
    <CommonModal
      width={1300}
      title={t("寻源需求申请")}
      centered
      open={open}
      onCancel={cleanup}
      footer={null}
    >
      <FlowFormPanelLayout
        leftPanel={
          <FormSectionLayout
            body={<SourcingRequirementApplicationForm form={form} />}
            footer={renderFooter(detail)}
          />
        }
        rightPanel={
          <ProcessTimeline
            items={timeLineItems}
            showFinishedFlag={isFlowFinished}
          />
        }
        showRightPanel={timeLineItems.length > 0}
      ></FlowFormPanelLayout>
    </CommonModal>
  );
}
